import { render, staticRenderFns } from "./list.vue?vue&type=template&id=2a01b400&scoped=true"
import script from "./list.ts?vue&type=script&lang=ts&external"
export * from "./list.ts?vue&type=script&lang=ts&external"
import style0 from "./list.less?vue&type=style&index=0&id=2a01b400&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a01b400",
  null
  
)

export default component.exports